var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_5096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5674 2.15106C11.1487 1.17226 12.5656 1.17226 13.1469 2.15106L20.7677 14.9841C21.3615 15.984 20.6409 17.25 19.478 17.25H4.23629C3.07339 17.25 2.35279 15.984 2.94657 14.9841L10.5674 2.15106Z",
    stroke: "#E98092"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1429,
    y: 5.42871,
    width: 1.42857,
    height: 7.14286,
    rx: 0.714286,
    fill: "#E98092"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1429,
    y: 14,
    width: 1.42857,
    height: 1.42857,
    rx: 0.714286,
    fill: "#E98092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_5096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.e877d81ea4f5438c108701004d9415ea.svg";
export { ForwardRef as ReactComponent };